module.exports = __webpack_public_path__ + "img/9blue.a530e71b.png";